export const MODELS = [
  { key: "gpt", name: "ChatGPT", version: "GPT 5.5", color: "#10B981", testid: "gpt-5-5" },
  { key: "claude", name: "Claude", version: "Sonnet 5.5", color: "#F97316", testid: "claude-5-5" },
  { key: "gemini", name: "Gemini", version: "3.1 Pro", color: "#06B6D4", testid: "gemini-3-1" },
];
